import { createFileRoute } from "@tanstack/react-router"
import Security from "@/components/account/security"

export const Route = createFileRoute("/_authed/account/security")({
  component: RouteComponent,
})

export default function RouteComponent() {
  return <Security />
}
